import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetBidAnalysisServiceCodesQuery } from 'generated/graphql'

import { BidAnalysisFilterValues } from './BidAnalysisFilterCriteria'
import { useBidAnalysisQueryInput } from './useBidAnalysisQueryInput'

export const BidAnalysisServiceCodeAutocomplete = () => {
  const { control } = useFormContext<BidAnalysisFilterValues>()
  const { start, end } = useBidAnalysisQueryInput()

  const { data } = useGetBidAnalysisServiceCodesQuery({
    variables: { input: { start, end } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.bidAnalysisServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={2}
      size='small'
      sx={{ minWidth: 180 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
